var _circle, _g, _rect, _rect2, _rect3, _rect4, _rect5, _path, _rect6, _rect7, _rect8, _rect9, _rect10, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconAssistantCtaPage3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 103,
    viewBox: "0 0 109 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1668_8729",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 103,
    height: 103
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 51.5,
    r: 51.5,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1668_8729)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 51.5,
    r: 51.5,
    fill: "#D6E8F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.529 55.1392C22.7619 55.1392 17.7476 55.8367 15.4613 56.1854L26.5053 66.6481C35.4179 64.3618 53.1474 59.8643 44.0834 57.6802C34.4345 55.3552 26.7378 55.1392 24.529 55.1392Z",
    fill: "#D7AE88"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3958 55.9581C17.4757 55.954 17.5179 55.9526 17.5179 55.9526L17.4443 56.0956C17.7902 57.0086 20.0793 62.0129 28.9505 62.8375C38.7223 63.7459 42.7619 57.3423 42.7619 57.3423C42.7619 57.3423 48.719 58.1949 51.191 59.4309C56.3577 64.3393 62.7484 72.0555 67.3757 77.6426C68.2831 78.7383 69.1228 79.7521 69.8721 80.6468C75.6847 76.9267 83.8182 72.8092 83.8182 72.8092L90.677 74.6692C90.677 74.6692 88.7858 78.5552 83.8182 82.5538C83.5308 82.7851 83.0914 83.1941 82.52 83.726C79.8862 86.1777 74.4493 91.2386 68.186 93.5239C62.006 90.3309 56.547 85.6959 52.118 77.3529C51.191 85.6959 54.1316 118.816 54.5226 119.659C55.4635 121.696 57.3127 124.885 57.3127 124.885C57.3127 124.885 22.4219 142.652 11.9582 138.097C11.4703 137.886 10.7535 136.748 10.7535 136.748L10.8503 116.755C-12.0912 96.6128 -5.80511 93.3448 -5.80511 93.3448C-6.13883 86.4916 -0.36891 68.5132 4.0143 61.6847C4.49519 60.9355 5.10251 60.284 5.79192 59.7173C5.91681 59.4534 6.00988 59.2963 6.05928 59.2564C6.74652 58.702 7.83169 58.2139 9.06422 57.7949C12.574 56.3072 16.4349 56.0118 17.3269 55.9618C17.3711 55.9557 17.3941 55.9526 17.3941 55.9526C17.3941 55.9526 17.3947 55.9545 17.3958 55.9581Z",
    fill: "#2974B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5818 27.4419C24.5818 27.4419 30.9243 51.0702 23.4841 55.2553C28.4355 57.8682 37.2298 57.8549 37.2298 57.8549L37.5941 50.5972C37.5941 50.5972 42.1069 51.4917 43.2806 47.2835C47.4321 38.1662 43.8472 23.7622 43.8472 23.7622L24.5818 27.4419Z",
    fill: "#D7AE88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5061 25.8764C43.5027 26.4456 43.0575 29.739 43.0575 29.739L39.9208 36.7121C38.322 35.4516 36.1769 35.5329 35.752 38.3588C35.4484 40.412 37.978 40.8186 37.978 40.8186C36.5007 43.3395 35.5091 45.3725 33.364 47.7713C31.0368 50.3532 29.7416 50.6175 27.2323 50.6581H24.4598C24.4598 50.6581 23.1039 46.2263 20.5946 35.1467C17.8019 22.8473 32.2712 24.433 34.9627 21.3023C39.3339 16.1995 51.8402 24.0671 45.5061 25.8764Z",
    fill: "#312C36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9308 17.216C45.9308 17.216 45.3642 17.6429 44.4333 18.0902C42.5918 18.944 39.3134 19.8385 35.8934 17.7242C35.3672 17.399 34.841 17.1753 34.3149 17.0534C29.9235 15.9352 25.7547 20.977 25.3095 21.5462C24.6417 22.2577 24.075 23.0506 23.6298 23.9248C21.9502 24.677 20.5336 25.9984 19.6837 27.6451C18.3075 30.3082 18.5302 34.7198 20.8776 36.3055L23.2656 35.5126C23.4275 35.8176 23.6298 36.1022 23.8727 36.3461C24.0548 36.5291 24.3179 36.6917 24.5607 36.773C24.8845 36.8747 25.2285 36.8544 25.4714 36.6511C25.7345 36.4274 25.8357 36.0615 25.8964 35.6956C25.9773 35.3093 26.0583 34.9231 26.1392 34.5368L43.2191 28.8242C43.1786 29.2714 43.0572 29.7187 42.8953 30.0846C42.8953 30.0846 42.8953 30.0846 42.9155 30.0846C42.9965 30.0846 43.3608 30.1049 43.8667 30.0033C44.9392 29.8 46.7201 29.1495 48.1164 27.0149C50.2817 23.7621 49.7354 18.8424 45.9308 17.216Z",
    fill: "#312C36"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 62.8307,
    y: 16.48,
    width: 45.938,
    height: 23.4107,
    rx: 5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 76.4281,
    y: 20.188,
    width: 28.016,
    height: 3.708,
    rx: 1.854,
    fill: "#40946A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 67.2489,
    y: 30.8208,
    width: 37.1038,
    height: 1.236,
    rx: 0.618,
    fill: "#C1C1C1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 67.2489,
    y: 27.1919,
    width: 37.1038,
    height: 1.236,
    rx: 0.618,
    fill: "#C1C1C1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 67.2489,
    y: 34.3545,
    width: 37.1038,
    height: 1.236,
    rx: 0.618,
    fill: "#C1C1C1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.1011 19.7759L69.614 23.0743L68.3705 21.9748L67.7758 22.6721L69.641 24.3079L73.7498 20.4463L73.1011 19.7759Z",
    fill: "#40946A",
    stroke: "#40946A",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 62.8307,
    y: 42.6421,
    width: 45.938,
    height: 23.4107,
    rx: 5,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 76.4281,
    y: 46.3501,
    width: 28.016,
    height: 3.708,
    rx: 1.854,
    fill: "#9F9E8F"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 67.2489,
    y: 56.9829,
    width: 37.1038,
    height: 1.236,
    rx: 0.618,
    fill: "#C1C1C1"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 67.2489,
    y: 53.354,
    width: 37.1038,
    height: 1.236,
    rx: 0.618,
    fill: "#C1C1C1"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 67.2489,
    y: 60.5166,
    width: 37.1038,
    height: 1.236,
    rx: 0.618,
    fill: "#C1C1C1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1011 45.938L69.614 49.2364L68.3705 48.1369L67.7758 48.8342L69.641 50.47L73.7498 46.6084L73.1011 45.938Z",
    fill: "#787B7D",
    stroke: "#787B7D",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.4014 73.9757C93.0604 73.221 94.1258 71.8314 94.5221 71.3104C95.1144 70.7222 95.793 70.0686 95.8706 70.082C95.9227 70.0909 95.9023 70.1608 95.8536 70.327L95.8536 70.327C95.8 70.5098 95.7124 70.809 95.6494 71.272C95.6082 71.6043 95.7659 71.8093 95.9684 71.9412C96.4359 72.2157 96.7676 71.6911 96.9506 71.1893C96.9977 71.0566 97.0428 70.9306 97.0859 70.8104C97.3294 70.1308 97.5045 69.6419 97.5625 69.2262C97.6922 68.2216 96.9649 68.0515 96.48 68.0468C96.5285 67.9836 96.5722 67.9181 96.6087 67.8498C96.7274 67.6278 96.7605 67.3426 96.6395 67.1116C96.5388 66.9489 96.3805 66.8408 96.1984 66.777C95.9901 66.7061 95.7719 66.6924 95.5586 66.7203C95.571 66.7034 95.5813 66.6873 95.5894 66.6721C95.7081 66.4502 95.7541 66.1834 95.6304 65.9681C95.5427 65.8237 95.3843 65.7156 95.2179 65.6546C94.9604 65.5617 94.6528 65.5733 94.3839 65.6401C94.3154 65.6571 94.2475 65.6773 94.1799 65.6999C94.3773 65.2904 94.7316 64.6735 95.3386 63.9299C96.6231 62.3575 97.1529 61.4307 96.1843 61.2637C95.2313 61.0994 91.5179 65.4691 91.5179 65.4691C91.4887 65.4805 91.0097 65.9736 90.3886 66.621C89.888 66.4522 89.2992 66.3436 88.9471 66.5844C88.5656 66.8389 88.3006 67.7187 88.1383 68.4686L82.6968 76.3278L84.5953 80.3815L90.288 74.2901C90.288 74.2901 91.661 74.8177 92.4014 73.9757Z",
    fill: "#D7AE88"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8424 72.8208L77.7654 77.6618C79.6194 79.1725 83.5334 82.0702 84.3574 81.5758C85.1814 81.0814 88.8894 76.8378 90.6404 74.7778C90.146 73.789 85.9024 73.0611 83.8424 72.8208Z",
    fill: "#2974B2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAssistantCtaPage3);
export default __webpack_public_path__ + "static/media/icon-assistant-cta-page-3.9d0d4ebde5c3b161e8bb67a36306cde1.svg";
export { ForwardRef as ReactComponent };